import { memo } from "react";

import { useSectionSettings } from "@react/sections/Root/SectionSettingsContext";
import { type ProductHeroSettings } from "@root/tablescape/state";

import { FootnotesView } from "./Footnotes.view";

type Props = {
  showCompareAtPriceValueFootnote: boolean;
  showReviewsFootnote: boolean;
};

const FootnotesBase = ({
  showCompareAtPriceValueFootnote,
  showReviewsFootnote,
}: Props) => {
  const {
    text: {
      footnotes: { bundleReviewsDisclaimer, bundleValueDisclaimer },
    },
  } = useSectionSettings<ProductHeroSettings>();

  return (
    <FootnotesView
      bundleReviewsDisclaimer={bundleReviewsDisclaimer}
      bundleValueDisclaimer={bundleValueDisclaimer}
      showCompareAtPriceValueFootnote={showCompareAtPriceValueFootnote}
      showReviewsFootnote={showReviewsFootnote}
    />
  );
};

export const Footnotes = memo(FootnotesBase);
